@if (display | async; as display) {
  <div
    data-cy="modal-container-bg"
    class="modal-container"
    (click)="modalService.disableClose ? null : closeModal()"
    (keydown.space)="modalService.disableClose ? null : closeModal()"
    (keydown.enter)="modalService.disableClose ? null : closeModal()"
    tabindex="0"
    [ngClass]="{
      'modal-container--toggled': display === 'open'
    }"
  >
    <div
      class="modal-window"
      (click)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      tabindex="0"
      [ngClass]="{
        'modal-window--consultant': modalService.consultCreateEfektikaStrategy,
        'modal-window--dynamic': modalService.investmentQuestionaireExpired || modalService.initSignIn || modalService.rebalancingSwitchoffConfirm || modalService.feeChangeConfirm || modalService.outdatedAmlClient || modalService.efektikaDraftAcceptConfirm || modalService.efektikaDraftAcceptRegularExceedConfirm || modalService.opfFeesConfirmClientId || modalService.deleteTemplateDraftConfirm || (modalService.newRegularWithdrawal && !modalService.newRegularWithdrawal.dip),
        'modal-window--small': modalService.rebalancingControl || modalService.dipControl || modalService.efektikaDraftAcceptDipConfirm || modalService.newPortfolioVatConfirm,
        'modal-window--fees': modalService.feeConfigs,
        'modal-window--thin': modalService.transactionsExportForm,
        'modal-window--save-template': modalService.saveStrategyTemplate,
      }"
    >
      @if (!modalService.disableClose) {
        <button class="button-close" (click)="closeModal()" data-cy="modal-close-button">
          <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'height.px':25, 'width.px':25 }"></svg-icon>
        </button>
      }
      <!-- whole modal preloader -->
      @if (modalService.preloader) {
        <div class="modal-preloader-container">
          <libero-preload-spinner></libero-preload-spinner>
        </div>
      }
      <!-- money deposit with QR -->
      @if (modalService.moneyDeposit) {
        <div #moneyDepositEl class="payment-desktop-padding" data-cy="money-deposit-modal-window">
          <div class="payment-desktop-layout">
            <div class="payment-desktop-layout-container">
              <h1 data-cy="deposit-modal-header">{{ 'modal.moneyDeposit' | translate }}</h1>
              @if (modalService.moneyDeposit.strategy) {
                <div class="strategy">
                  @if (modalService.moneyDeposit.new) {
                    <div>
                      {{ (modalService.moneyDeposit.consultView?.clientId ? 'modal.consultPortfolioPartOne' : 'modal.newStrategyPartOne') | translate }}
                      "{{ modalService.moneyDeposit.name }}"
                      {{ 'modal.newStrategyPartTwo' | translate }}
                    </div>
                  } @else {
                    {{ (modalService.moneyDeposit.consultView?.clientId ? 'modal.consultPortfolioPartOne' : 'modal.existingStrategyPartOne') | translate }}
                    "{{ modalService.moneyDeposit.name }}"
                    {{ 'modal.existingStrategyPartTwo' | translate }}
                  }
                </div>
              }
              @if (modalService.moneyDeposit.portfolio) {
                <div class="portfolio">
                  @if (modalService.moneyDeposit.new) {
                    <div>
                      {{ (modalService.moneyDeposit.consultView?.clientId ? 'modal.consultPortfolioPartOne' : 'modal.existingPortfolioPartOne') | translate }}
                      "{{ modalService.moneyDeposit.name }}"
                      {{ 'modal.existingPortfolioPartTwo' | translate }}
                    </div>
                  } @else {
                    {{ (modalService.moneyDeposit.consultView?.clientId ? 'modal.consultPortfolioPartOne' : 'modal.existingPortfolioPartOne') | translate }}
                    "{{ modalService.moneyDeposit.name }}"
                    {{ 'modal.existingPortfolioPartTwo' | translate }}
                  }
                </div>
              }
              <hr class="divider">
              @if (!modalService.moneyDeposit.consultView?.clientId) {
                <div class="deposit-money" data-cy="deposit-bank-details">
                  {{ 'modal.nowDepositMoney' | translate }}
                </div>
              }
              <div class="payment-info-container">
                <div class="row payment-info" data-cy="deposit-bank-account-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.accountNumber' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ modalService.moneyDeposit.accountNumber }} / {{ modalService.moneyDeposit.bankCode }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-variable-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.variableSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ modalService.moneyDeposit.variableSymbol }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-specific-symbol-header">
                  <div class="col-12 payment-info--label">
                    {{ 'modal.specificSymbols' | translate }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-regular-specific-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.regularSpecificSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ configService.getConfig(EnvironmentKeys.regularSpecificCode) }}
                  </div>
                </div>
                <div class="row payment-info" data-cy="deposit-one-time-specific-symbol-col">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.oneTimeSpecificSymbol' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    {{ configService.getConfig(EnvironmentKeys.oneTimeSpecificCode) }}
                  </div>
                </div>
              </div>
              <div class="footer-description desktop-content" data-cy="deposit-footer-description">
                {{ (modalService.moneyDeposit.consultView?.clientId ? 'modal.consultMoneyDepositFooterDescriptionPart1' : 'modal.moneyDepositFooterDescriptionPart1') | translate }}
                <b>
                  {{ 'modal.moneyDepositFooterDescriptionPart2' | translate }}
                </b>
                {{ 'modal.moneyDepositFooterDescriptionPart3' | translate }}
                <hr class="divider divider--no-spacing mt-2">
              </div>
              @if (modalService.moneyDeposit.totalEntryFee) {
                <div data-cy="total-fee-container" class="row payment-info">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.totalEntryFee' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    <div class="tooltipped-value">
                      {{ modalService.moneyDeposit.totalEntryFee | price:modalService.moneyDeposit.currency }}
                      <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                        {{ 'modal.initialFeeTooltipPart1' | translate }}
                        <b>
                          {{ 'modal.initialFeeTooltipPart2' | translate }}
                          {{ configService.getConfig(EnvironmentKeys.regularSpecificCode) }}
                        </b>
                        {{ 'modal.initialFeeTooltipPart3' | translate }}.
                      </libero-tooltip-button>
                    </div>
                  </div>
                </div>
              }
              @if (modalService.moneyDeposit.vatAlreadyPaid && modalService.moneyDeposit.entryFeeAlreadyPaidWithVat) {
                <div data-cy="portfolio-paid-VAT--container" class="row payment-info payment-info--downsized">
                  <div class="col-6 payment-info--label">
                    {{ 'modal.entryFeeAlreadyPaid' | translate }}
                  </div>
                  <div class="col-6 payment-info--value">
                    <b data-cy="already-paid-fee-with-VAT">{{ modalService.moneyDeposit.entryFeeAlreadyPaidWithVat | price:modalService.moneyDeposit.currency }}</b>
                  </div>
                  <div class="col-12">
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt1' | translate }}
                    <b data-cy="already-paid-fee">{{ modalService.moneyDeposit.feeAlreadyPaid | price:modalService.moneyDeposit.currency }}</b>
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt2' | translate }}
                    <b data-cy="already-paid-VAT">{{ modalService.moneyDeposit.vatAlreadyPaid | price:modalService.moneyDeposit.currency }}</b>
                    {{ 'modal.portfolioVAT.vatAlreadyPaidPt3' | translate }}
                  </div>
                </div>
              } @else {
                @if (
                  modalService.moneyDeposit.regularDeposit &&
                  ((modalService.moneyDeposit.vatAlreadyPaid === 0)
                  && ( modalService.moneyDeposit.entryFeeAlreadyPaidWithVat === 0)
                  || (modalService.moneyDeposit.entryFeeAlreadyPaid || modalService.moneyDeposit.entryFeeAlreadyPaid === 0))) {
                  <div
                    data-cy="already-paid-container"
                    class="row payment-info"
                    >
                    <div class="col-6 payment-info--label">
                      {{ 'modal.entryFeeAlreadyPaid' | translate }}
                    </div>
                    <div class="col-6 payment-info--value">
                      {{ modalService.moneyDeposit.entryFeeAlreadyPaid ?? 0 | price:modalService.moneyDeposit.currency }}
                    </div>
                  </div>
                }
              }
              @if (modalService.moneyDeposit.unpaidAmountWithVat) {
                <div data-cy="unpaid-VAT-container" class="row payment-info">
                  <div class="col-6 payment-info--label">
                    {{ ('modal.portfolioVAT.' + (modalService.moneyDeposit.portfolio ? 'totalUnpaidEntryFeeWithVAT' : 'totalEntryFeeWithoutVAT') ) | translate }}
                  </div>
                  <div class="col-6 payment-info--value" data-cy="unpaid-with-VAT">
                    {{ modalService.moneyDeposit.unpaidAmountWithVat | price:modalService.moneyDeposit.currency }}
                  </div>
                </div>
              }
            </div>
            <div class="qr-container" data-cy="deposit-qr-container">
              <div class="qr-code">
                <div class="qr-payment-label" data-cy="deposit-regular-qr-desc">
                  {{ 'modal.regularQr' | translate }}
                </div>
                <libero-qr-payment
                  [accountNumber]="modalService.moneyDeposit.accountNumber"
                  [variableSymbol]="modalService.moneyDeposit.variableSymbol"
                  [specificSymbol]="configService.getConfig(EnvironmentKeys.regularSpecificCode)"
                  [amount]="modalService.moneyDeposit.regularDeposit"
                  [bankCode]="modalService.moneyDeposit.bankCode"
                  [currency]="modalService.moneyDeposit.currency"
                  data-cy="deposit-regular-qr"
                ></libero-qr-payment>
              </div>
              <div class="qr-code">
                <div class="qr-payment-label" data-cy="deposit-one-time-qr-desc">
                  {{ 'modal.oneTimeQr' | translate }}
                </div>
                <libero-qr-payment
                  [accountNumber]="modalService.moneyDeposit.accountNumber"
                  [variableSymbol]="modalService.moneyDeposit.variableSymbol"
                  [specificSymbol]="configService.getConfig(EnvironmentKeys.oneTimeSpecificCode)"
                  [bankCode]="modalService.moneyDeposit.bankCode"
                  [currency]="modalService.moneyDeposit.currency"
                  data-cy="deposit-one-time-qr"
                ></libero-qr-payment>
              </div>
              <div class="generate-pdf-container">
                @if (modalService.paymentInfoPreloader) {
                  <div class="generate-pdf-preloader">
                    <libero-preload-spinner></libero-preload-spinner>
                  </div>
                } @else {
                  <div
                    class="generate-pdf-text"
                    (click)="modalService.generatePaymentInfoPdf()"
                    (keydown.space)="modalService.generatePaymentInfoPdf()"
                    (keydown.enter)="modalService.generatePaymentInfoPdf()"
                    tabindex="0"
                  >
                    {{ 'modal.generatePaymentInfoPdf' | translate }}
                  </div>
                }
              </div>
              @if (modalService.moneyDeposit.dip) {
                <div class="generate-pdf-container">
                  @if (modalService.dipPreloader) {
                    <div class="generate-pdf-preloader">
                      <libero-preload-spinner></libero-preload-spinner>
                    </div>
                  } @else {
                    {{ 'modal.generateDipQr' | translate }}
                    <div
                      class="generate-pdf-text"
                      (click)="modalService.generateDipPdf()"
                      (keydown.space)="modalService.generateDipPdf()"
                      (keydown.enter)="modalService.generateDipPdf()"
                      tabindex="0"
                    >
                      {{ 'modal.generate' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="footer-description phone-content">
            {{ 'modal.moneyDepositFooterDescriptionPart1' | translate }}
            <b>
              {{ 'modal.moneyDepositFooterDescriptionPart2' | translate }}
            </b>
            {{ 'modal.moneyDepositFooterDescriptionPart3' | translate }}
          </div>
        </div>
      }
      <!-- rebalancing confirm -->
      @if (modalService.rebalancingControl) {
        <div>
          <div class="rebalancing-content">
            {{ 'modal.rebalancingDescription' | translate }}
            <div class="mt-4">
              {{ 'modal.rebalancingQuestion' | translate }}
              <div class="rebalancing-tooltip-container">
                <libero-tooltip-button>
                  {{ 'global.tooltips.rebalancing' | translate }}
                </libero-tooltip-button>
              </div>
            </div>
          </div>
          <div class="rebalancing-buttons-container">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.activate' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmRebalancing()"
              data-cy="confirm-rebalancing-btn"
            ></libero-button>
          </div>
        </div>
      }
      <!-- DIP confirm -->
      @if (modalService.dipControl || modalService.efektikaDraftAcceptDipConfirm) {
        <div>
          <div class="rebalancing-content">
            @if (modalService.dipOpenSource === 'new-portfolio') {
              {{ 'modal.dipExplainNewPortfolio' | translate }}
            }
            @if (modalService.dipOpenSource === 'new-strategy') {
              {{ 'modal.dipExplainNewStrategy' | translate }}
            }
          </div>
          <div class="rebalancing-buttons-container">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--icon-text icon--secondary"
              (click)="modalService.close()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.yes' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.efektikaDraftAcceptDipConfirm ? modalService.confirmDipEfektika() : modalService.confirmDip()"
              [preloader]="!!(modalService.efektikaDraftAcceptDipConfirm && modalService.efektikaDraftAcceptDipConfirm.loading)"
            ></libero-button>
          </div>
        </div>
      }
      <!-- investment questionaire disabled -->
      @if (modalService.investmentQuestionaireExpired) {
        <div data-cy="questionaire-expired-modal">
          <div class="investment-questionaire-expired">
            <h3>{{ 'modal.investmentQuestionaireExpired' | translate }}</h3>
            <p>{{ 'modal.investmentQuestionaireExpiredInfo' | translate }}</p>
            <libero-button
              label="{{ 'global.buttons.fillinQuestionaire' | translate }}"
              btnClasses="btn--primary"
              (click)="goToInvestmentQuestionaireForm()"
            ></libero-button>
          </div>
        </div>
      }
      <!-- confirmation of rebalancing disable -->
      @if (modalService.rebalancingSwitchoffConfirm) {
        <div>
          <div class="investment-rebalancing-confirm" data-cy="investment-rebalancing-confirm">
            <p>{{ 'modal.investmentRebalancingConfirm' | translate }}</p>
            <div class="confirm-disable-realancing">
              <libero-button
                label="{{ 'modal.backFromRebalancingConfirm' | translate }}"
                btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
                (click)="closeModal()"
              ></libero-button>
              <libero-button
                label="{{ 'modal.confirmRebalancing' | translate }}"
                btnClasses="btn--primary btn--responsive-height"
                (click)="modalService.confirmRebalancingSwitchoff()"
                data-cy="investment-rebalancing-confirm-btn"
              ></libero-button>
            </div>
          </div>
        </div>
      }
      <!-- confirmation of fees change -->
      @if (modalService.feeChangeConfirm) {
        <div>
          <div class="investment-fees-change" data-cy="investment-fees-change-modal">
            <p [innerHTML]="'modal.changeStrategyFees.reason' | translate"></p>
            <p class="pb-5">{{ 'modal.changeStrategyFees.highlightedReason' | translate }}</p>
            <div class="confirm-fees-change">
              <libero-button
                label="{{ 'global.buttons.back' | translate }}"
                btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
                (click)="closeModal()"
              ></libero-button>
              <libero-button
                label="{{ 'modal.changeStrategyFees.confirm' | translate }}"
                btnClasses="btn--primary btn--responsive-height"
                (click)="modalService.confirmFeesChange()"
                data-cy="confirm-fees-change-btn"
              ></libero-button>
            </div>
          </div>
        </div>
      }

      <!-- outdated aml (consult only) -->
      @if (modalService.outdatedAmlClient) {
        <div class="outdated-aml" data-cy="outdated-aml-modal">
          {{ 'modal.outdatedAml1' | translate }}
          {{ 'modal.outdatedAml2' | translate }}
          <libero-button
            label="{{ 'global.continue' | translate }}"
            btnClasses="btn--primary btn--heading"
            (click)="modalService.navigateConsultClientToInvestmentGoal()"
            data-cy="continue-aml-btn"
          ></libero-button>
        </div>
      }

      <!-- portfolio VAT confirm -->
      @if(!modalService.preloader && modalService.newPortfolioVatConfirm) {
        <div class="vat-confirmation">
          <p><b>{{ 'modal.vatConfirm.heading' | translate }}</b></p>
          <p [innerHTML]="'modal.vatConfirm.desc' | translate"></p>
          <div class="confirm-vat-buttons">
            <libero-button
              label="{{ 'global.buttons.back' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'modal.vatConfirm.btn' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.handlePortfolioVatAccept()"
              data-cy="modal-confirm-VAT-investment-button"
            ></libero-button>
          </div>
        </div>
      }

      <!-- fee configs -->
      @if (!modalService.preloader && modalService.feeConfigs) {
        <div class="fee-config-modal-container" data-cy="fee-config-modal">
          <div class="fee-heading">
            {{ 'modal.feeConfigs.header' | translate }}
          </div>
          @if(modalService.feeConfigs.feeSchemeName) {
            <div class="framework-name">
              {{ modalService.feeConfigs.feeSchemeName }}
            </div>
          }
          @if (modalService.feeConfigs.regularEntryFeeConfig) {
            <div class="fee-wrapper">
              <libero-fees-entry-regular-config-dropdown
                [feeAmounts]="modalService.feeConfigs.entryFeeInfo"
                [feeConfig]="modalService.feeConfigs.regularEntryFeeConfig"
                [hasVat]="modalService.feeConfigs.hasVat"
                [opfFeeImplVariant]="opfFeeImplVariant"
              ></libero-fees-entry-regular-config-dropdown>
            </div>
          }
          <div class="fee-wrapper fee-wrapper--config">
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.oneTimeEntryFeeConfig.entryFee"
              [type]="'entry'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.mngFeeConfig.mngFee"
              [type]="'management'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.performanceFeeConfig.performanceFee"
              [type]="'performance'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
            @if (modalService.feeConfigs.opfFeeImplementation) {
              <libero-fees-config-dropdown
                [amount]="modalService.feeConfigs.variableServiceFeeConfig.variableServiceFee"
                [type]="'variableService'"
                [opfFeeImplVariant]="opfFeeImplVariant"
                data-cy="variable-service-fee-config-dropdown"
              ></libero-fees-config-dropdown>
            }
            <libero-fees-config-dropdown
              [amount]="modalService.feeConfigs.exitFeeConfig.exitFee"
              [type]="'exit'"
              [opfFeeImplVariant]="opfFeeImplVariant"
            ></libero-fees-config-dropdown>
          </div>
          @if(modalService.feeConfigs.opfFeeImplementation) {
            <p class="fees-footer-info" data-cy="fee-config-modal-footer-text">
              {{ 'modal.feeConfigs.footerInfo' | translate }}
            </p>
          }
        </div>
      }
      <!-- investment create confirm (efektika draft) -->
      @if (modalService.efektikaDraftAcceptRegularExceedConfirm && modalService.efektikaModalChainingDraftData) {
        <div class="create-confirm-container" data-cy="create-efektika-invesment-confirm-modal">
          <p>
            {{ 'modal.createConfirm.confirmTextStrategyPt1' | translate }}
            "{{ modalService.efektikaModalChainingDraftData.name }}"
            {{ 'modal.createConfirm.confirmTextPt2' | translate }}
            {{ modalService.efektikaModalChainingDraftData.regularDeposit | price:'CZK' }}.
            {{ 'modal.createConfirm.confirmTextPt3' | translate }}
          </p>
          <div class="confirm-create-buttons">
            <libero-button
              label="{{ 'global.buttons.goBack' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="closeModal()"
            ></libero-button>
            <libero-button
              label="{{ 'global.buttons.confirm' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="modalService.confirmRegularExceededEfektika()"
              data-cy="modal-create-investment-button"
              [preloader]="!!(modalService.efektikaDraftAcceptRegularExceedConfirm && modalService.efektikaDraftAcceptRegularExceedConfirm.loading)"
            ></libero-button>
          </div>
        </div>
      }

      <libero-transactions-export-modal
        [show]="modalService.transactionsExportForm"
        (onExportFinish)="modalService.close()"
      ></libero-transactions-export-modal>

      <libero-save-strategy-template-modal
        [show]="modalService.saveStrategyTemplate"
        [saving]="modalService.saveStrategyTemplateSaving"
        (backBtnClick)="modalService.close()"
        (createBtnClick)="modalService.createSaveStrategyTemplate($event)"
      ></libero-save-strategy-template-modal>

      <libero-new-regular-withdrawal-modal
        [show]="modalService.newRegularWithdrawal && !!loggedConsult"
        (continueBtnClick)="modalService.continueToWidthdrawalDraftComment()"
        (backBtnClick)="modalService.close()"
      ></libero-new-regular-withdrawal-modal>

      <libero-opf-fee-confirm-modal
        [show]="!!modalService.opfFeesConfirmClientId && !modalService.preloader"
        (continueBtnClick)="modalService.confirmOpfTransfer()"
        (backBtnClick)="modalService.close()"
      ></libero-opf-fee-confirm-modal>

      <libero-consult-create-efektika-strategy-modal
        [show]="modalService.consultCreateEfektikaStrategy && !!loggedConsult"
        (continueBtnClick)="modalService.confirmConsultCreatingEfektika()"
        (backBtnClick)="modalService.close()"
      ></libero-consult-create-efektika-strategy-modal>

      @if(!modalService.preloader) {
        <libero-template-draft-delete-modal
          [templateDraft]="modalService.deleteTemplateDraftConfirm"
          (continueBtnClick)="modalService.onDeleteTemplateDraftConfirm()"
          (backBtnClick)="modalService.close()"
        ></libero-template-draft-delete-modal>
      }

      <!-- default content -->
      <ng-content>
      </ng-content>
      @if (!modalService.preloader && modalService.apiError) {
        <div class="api-error-container" data-cy="api-error-container">
          {{ 'global.error.loadData' | translate }}
        </div>
      }
    </div>
  </div>
}
